import { GAME_TYPE_KO_MIXED } from './gameTypeMixin'
export const GAME_MODE_SINGLEPLAYER = '1vs1'
export const GAME_MODE_TEAM_XVSX = 'XvsX'
export const GAME_MODE_TEAM_COOP = 'coop'
export const GAME_MODE_TEAM_VBL = 'vbl'

export default {
  methods: {
    gameModeIsAnyTeamMode(type) {
      return type == GAME_MODE_TEAM_XVSX || type == GAME_MODE_TEAM_COOP || type == GAME_MODE_TEAM_VBL
    },
    gameModeIsVbl(type){
      return type == GAME_MODE_TEAM_VBL
    },
    gameTypeIsKoMixed(type){
      return type == GAME_TYPE_KO_MIXED
    },
    gameModeIsSingleplayer(type) {
      return type == GAME_MODE_SINGLEPLAYER
    },
    getGameModeLabel(type) {
      return this.$t(`teamMode.${type}_long`);
    },
    getGameModeIcon(type) {
      if (type == GAME_MODE_SINGLEPLAYER) {
        return "mdi-account";
      } else if (type == GAME_MODE_TEAM_XVSX || type == GAME_MODE_TEAM_COOP || type == GAME_MODE_TEAM_VBL) {
        return "mdi-account-multiple";
      }
      return "mdi-help";
    },
    getGameModeLabelByGame(game) {
      let teamSize = game.teamSize
      if (teamSize) {
        if (game.mode == GAME_MODE_TEAM_COOP) {
          return this.$t(`teamMode.${game.mode}`) + ` (${teamSize})`
        } else {
          return this.$t(`teamMode.${game.mode}`) + ` (${teamSize} vs ${teamSize})`
        }
      } else {
        return this.$t(`teamMode.${game.mode}`)
      }
    }
  }
}
